import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { actualizarProyecto, agregarProducto } from "../../../service/AffariService";

const TableDetalleCotizacion = ({
    idCotizacion,
    detalles,
    relacionados,
    onUpdateLine,
    onRemoveLine,
    tipo,
    proyectos,
    proyecto,
    onRefresh,
    onChangeCantidad,
    onNotify,
    confirming,
    almacenes
}) => {

    const normalizeProyecto = (value) => (value === '0' || value === 0 ? null : value);

    const [proyectoSeleccionado, setProyectoSeleccionado] = useState(normalizeProyecto(proyecto));

    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const normalized = normalizeProyecto(proyecto);
        if (proyectoSeleccionado == null && normalized != null) {
            setProyectoSeleccionado(normalized);
        }
    }, [proyecto, proyectoSeleccionado]);

    const handleProyectoChange = (e) => {
        const nuevoProyecto = e.value;
        setProyectoSeleccionado(nuevoProyecto);
        if (idCotizacion && nuevoProyecto) {
            actualizarProyecto(idCotizacion, nuevoProyecto)
                .then(response => {
                    console.log("Proyecto actualizado:", response);
                    // if (onNotify) onNotify('success', 'Proyecto actualizado', '');
                    if (onRefresh) onRefresh();
                })
                .catch(error => {
                    console.error("Error actualizando proyecto:", error);
                    if (onNotify) onNotify('error', 'Error actualizando proyecto', error.message || '');
                });
        }
    };

    const addRelacionado = async (codigo) => {
        try {
            await agregarProducto(idCotizacion, codigo);
            // if (onNotify) onNotify('success', 'Producto agregado', `Código ${codigo}`);
            if (onRefresh) onRefresh();
        } catch (error) {
            console.error('Error agregando producto:', error);
            if (onNotify) onNotify('error', 'Error agregando producto', 'El producto ya fue agregado o no existe.' || error.message);
        }
    };

    const MobileRow = ({ rowData, index }) => (
        <div className="surface-card border-1 surface-border border-round p-3 mb-3">
            <div className="flex justify-content-between align-items-center mb-2">
                <span className="text-500">#{index + 1}</span>
                <Button icon="pi pi-trash" className="p-button-text p-button-danger p-button-sm" onClick={() => onRemoveLine(index)} />
            </div>
            <div className="flex flex-column gap-2">
                <div className="flex flex-column">
                    <span className="text-600 text-sm">Cantidad</span>
                    <InputNumber
                        value={rowData.cantidad}
                        onValueChange={(e) => onChangeCantidad(e.value ?? 0, rowData.id)}
                        inputClassName="p-inputtext-sm text-center"
                        min={0}
                        step={1}
                        minFractionDigits={0}
                        maxFractionDigits={0}
                        placeholder="0"
                        disabled={confirming}
                        showButtons={false}
                    />
                </div>

                <div className="flex justify-content-between">
                    <span className="text-600 text-sm">Artículo</span>
                    <span className="text-900">{rowData.referencia}</span>
                </div>
                
                <div className="flex flex-column">
                    <span className="text-600 text-sm">Descripción</span>
                    <span className="text-900" style={{ whiteSpace: 'normal' }}>{rowData.descripcion}</span>
                </div>

                {tipo === 'MAYORISTA' ? (
                    <div className="flex flex-column">
                        <span className="text-600 text-sm">Centro</span>
                        <Dropdown
                            value={rowData.centro}
                            options={almacenes || []}
                            optionLabel="sucursal"
                            optionValue="almacen"
                            onChange={(e) => onUpdateLine(index, 'centro', e.value)}
                            className="p-inputtext-sm"
                            disabled={confirming}
                            placeholder="Seleccione centro"
                        />
                    </div>
                ) : (
                    confirming ? (
                        <div className="flex flex-column">
                            <span className="text-600 text-sm">Centro</span>
                            <Dropdown
                                value={rowData.centro}
                                options={almacenes || []}
                                optionLabel="sucursal"
                                optionValue="almacen"
                                onChange={(e) => onUpdateLine(index, 'centro', e.value)}
                                className="p-inputtext-sm"
                                placeholder="Seleccione centro"
                            />
                        </div>
                    ) : null
                )}

                <div className="flex justify-content-between">
                    <span className="text-600 text-sm">Precio Lista</span>
                    <span className="text-900">{Number(rowData.precio_lista ?? 0).toLocaleString('es-CL')}</span>
                </div>

                <div className="flex flex-column">
                    <span className="text-600 text-sm">Precio</span>
                    <InputNumber
                        value={rowData.precio}
                        onValueChange={(e) => onUpdateLine(index, 'precio', e.value)}
                        className="w-full"
                        inputClassName="p-inputtext-sm text-right"
                        min={0}
                        locale="es-CL"
                        useGrouping={false}
                        disabled={confirming}
                    />
                </div>

                <div className="flex flex-column">
                    <span className="text-600 text-sm">Desc</span>
                    <InputNumber
                        value={rowData.descuento}
                        onValueChange={(e) => onUpdateLine(index, 'descuento', e.value)}
                        className="w-full"
                        inputClassName="p-inputtext-sm text-right"
                        min={0}
                        max={100}
                        mode="decimal"
                        locale="es-CL"
                        minFractionDigits={3}
                        maxFractionDigits={3}
                        step={0.001}
                        suffix=" %"
                        disabled={confirming}
                    />
                </div>
                <div className="flex justify-content-between">
                    <span className="text-600 text-sm">Total</span>
                    <span className="text-900">{(rowData.total ?? 0).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</span>
                </div>
            </div>
        </div>
    );

    return (
        <div className="grid">
            <div className={`col-12 ${confirming ? 'md:col-12' : 'md:col-9'}`}>
                {isMobile ? (
                    <div className="flex flex-column">
                        {Array.isArray(detalles) && detalles.length > 0 ? detalles.map((row, idx) => (
                            <MobileRow key={row.id ?? idx} rowData={row} index={idx} />
                        )) : (
                            <div className="surface-card border-1 surface-border border-round p-3 text-center text-600">Agregue productos para ver la cotización</div>
                        )}
                    </div>
                ) : (
                <DataTable
                    value={detalles}
                    tableStyle={isMobile ? null : { minWidth: "50rem"}}
                    size="small"
                    className="p-datatable-sm datatable-responsive border border-1 border-solid border-gray-300"
                    globalFilterFields={["cliente.razonSocial"]}
                    stripedRows
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                    currentPageReportTemplate="{first} - {last} de {totalRecords}"
                    scrollHeight={isMobile ? null : "35vh"}
                    style={{ minHeight: '35vh' }}
                    scrollable={!isMobile}
                    emptyMessage="Agregue productos para ver la cotización"
                >
                    <Column
                        header="#"
                        body={(rowData, options) => (
                            <Button
                                icon="pi pi-trash"
                                className="p-button-text p-button-danger p-button-sm"
                                onClick={() => onRemoveLine(options.rowIndex)}
                            />
                        )}
                        headerClassName="border-right-1 surface-border border-bottom-0"
                        style={{ width: isMobile ? '2rem' : '2rem' }}
                    />
                    <Column
                        header="Cantidad"
                        style={{ width: isMobile ? '6rem' : '7rem' }}
                        body={(rowData, options) => (
                            <InputNumber
                                value={rowData.cantidad}
                                onValueChange={(e) => onChangeCantidad(e.value ?? 0, rowData.id)}
                                inputClassName="p-inputtext-sm text-center"
                                min={0}
                                step={1}
                                minFractionDigits={0}
                                maxFractionDigits={0}
                                placeholder="0"
                                disabled={confirming}
                                showButtons={!isMobile}
                            />
                        )}
                        headerClassName="border-right-1 surface-border border-bottom-0"
                    />
                    {!isMobile && confirming && (
                        <Column
                            header="Stock"
                            style={{ width: '4rem' }}
                            body={(rowData) => Math.round(rowData.stock ?? 0)}
                            className="text-center"
                            headerClassName="border-right-1 surface-border border-bottom-0"
                        />
                    )} 
                    <Column
                        field="referencia"
                        header="Artículo"
                        style={{ minWidth: '7rem' }}
                        sortable
                        headerClassName="border-right-1 surface-border border-bottom-0"
                    />
                    {tipo === 'MAYORISTA' && (
                        <Column
                            header="Centro"
                            style={{ width: '8rem' }}
                            body={(rowData, options) => (
                                <Dropdown
                                    value={rowData.centro}
                                    options={almacenes || []}
                                    optionLabel="sucursal"
                                    optionValue="almacen"
                                    onChange={(e) => onUpdateLine(options.rowIndex, 'centro', e.value)}
                                    className="w-full p-inputtext-sm"
                                    disabled={confirming}
                                    placeholder="Seleccione centro"
                                />
                            )}
                            headerClassName="border-right-1 surface-border border-bottom-0"
                        />
                    )}
                    {confirming && (
                        <Column
                            header="Centro"
                            style={{ width: '8rem' }}
                            body={(rowData, options) => (
                                <Dropdown
                                    value={rowData.centro}
                                    options={almacenes || []}
                                    optionLabel="sucursal"
                                    optionValue="almacen"
                                    onChange={(e) => onUpdateLine(options.rowIndex, 'centro', e.value)}
                                    className="w-full p-inputtext-sm"
                                    placeholder="Seleccione centro"
                                />
                            )}
                            headerClassName="border-right-1 surface-border border-bottom-0"
                        />
                    )}
                    <Column
                        field="descripcion"
                        header="Descripción"
                        style={{ minWidth: '10rem' }}
                        sortable
                        headerClassName="border-right-1 surface-border border-bottom-0"
                    />
                    {!isMobile && (
                        <Column
                            field="um"
                            header="UM"
                            style={{ width: '3rem' }}
                            headerClassName="border-right-1 surface-border border-bottom-0"
                        />
                    )}
                    {!isMobile && (
                        <Column
                            header="Precio Lista"
                            style={{ width: '8rem' }}
                            field="precio_lista"
                            sortable
                            headerClassName="border-right-1 surface-border border-bottom-0"
                        />
                    )}
                    <Column
                        header="Precio"
                        style={{ width: '7rem' }}
                        field="precio"
                        body={(rowData, options) => (
                            <InputNumber
                                value={rowData.precio}
                                onValueChange={(e) => onUpdateLine(options.rowIndex, 'precio', e.value)}
                                className="w-full"
                                inputClassName="p-inputtext-sm text-right"
                                min={0}
                                locale="es-CL"
                                useGrouping={false}
                                disabled={confirming}
                            />
                        )}
                        sortable
                        headerClassName="border-right-1 surface-border border-bottom-0"
                    />
                    <Column
                        header="Desc"
                        style={{ width: '5.5rem' }}
                        body={(rowData, options) => (
                            <InputNumber
                                value={rowData.descuento}
                                onValueChange={(e) => onUpdateLine(options.rowIndex, 'descuento', e.value)}
                                className="w-full"
                                inputClassName="p-inputtext-sm text-right"
                                min={0}
                                max={100}
                                mode="decimal"
                                locale="es-CL"
                                minFractionDigits={3}
                                maxFractionDigits={3}
                                step={0.001}
                                suffix=" %"
                                disabled={confirming}
                            />
                        )}
                        sortable
                        headerClassName="border-right-1 surface-border border-bottom-0"
                    />
                    <Column
                        header="Total"
                        style={{ width: '7rem' }}
                        body={(rowData) => (rowData.total ?? 0).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}
                        sortable
                    />
                </DataTable>
                )}
            </div>
            {tipo !== 'MAYORISTA' && !confirming && (
                <>
                    <div className="col-12 md:col-3">
                        <div className="flex flex-column gap-2 h-full">
                            <Dropdown 
                                id="proyecto" 
                                value={proyectoSeleccionado} 
                                options={proyectos || []} 
                                onChange={handleProyectoChange} 
                                optionLabel="descripcion" 
                                optionValue="id" 
                                placeholder="Seleccione un proyecto" 
                                className="p-inputtext-sm" 
                                size="small" 
                            />
                            <DataTable 
                                value={relacionados} 
                                size="small" 
                                className="p-datatable-sm border-1 surface-border border-round flex-1 datatable-responsive" 
                                stripedRows
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                                scrollHeight={isMobile ? null : "30vh"}
                                style={{ minHeight: '30vh' }}
                                scrollable={!isMobile}
                                emptyMessage="No hay productos relacionados"
                            >
                                <Column field="codigo" header="Código" sortable body={(rowData) => (
                                    <span className="text-primary cursor-pointer" onClick={() => addRelacionado(rowData.codigo)}>
                                        {rowData.codigo}
                                    </span>
                                )} 
                                    headerClassName="border-right-1 surface-border border-bottom-0"
                                />
                                <Column field="descripcion" header="Descripción" sortable/>
                            </DataTable>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default TableDetalleCotizacion;
